import IServerOperation from './interface/IServerOperation'

/**
 * 擦除
 */
export default class Erase extends IServerOperation {
    constructor(serviceUrl, proxyUrl) {
        super('difference', serviceUrl, proxyUrl)
    }
}
